<!-- ----------------------------------------------- -->
<template>
  <v-container class="regist-point pa-0">
    <v-col class="rp-box pa-0">
      <div class="rp-tab">
        <v-row>
          <v-btn
            v-for="(point, idx) in pointList"
            :key="idx"
            class="rp-tab-btn mr-2"
            :class="{ 'com-btn-on': getPointIndex === point.pointIndex }"
            @click="setPointIndex(point.pointIndex)"
          >
            {{ setPointName(point.name) }}
          </v-btn>
        </v-row>
      </div>
      <div class="rp-card-list">
        <div class="rp-scroll pb-2">
          <rp-twninfo :point="getPointIndex + 1"></rp-twninfo>
          <rp-inundation :point="getPointIndex + 1"></rp-inundation>
          <rp-evacuation :point="getPointIndex + 1"></rp-evacuation>
          <rp-tm-list :point="getPointIndex + 1"></rp-tm-list>
        </div>
      </div>
    </v-col>
    <!-- ダイアログ -->
    <v-card v-if="riskFlg === 1" class="rp-dialog-content mt-0 pt-0">
      <v-card class="ma-4 rp-dialog-card">
        <div class="rp-dialog-header pl-4">
          <span class="rp-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div class="rp-dialog-box rp-dialog-box-confirm pl-4">
          {{ text.confirmInfoMsg1 }}
          <br />
          {{ text.confirmInfoMsg2 }}
        </div>
        <div class="rp-dialog-box pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="confirm"
          >
            <v-icon left>add_box</v-icon>
            {{ text.confirm }}
          </v-btn>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="cancelConfirm"
          >
            <v-icon left>clear</v-icon>
            {{ text.cancel }}
          </v-btn>
        </div>
      </v-card>
    </v-card>
    <!-- リスク判定時のメッセージ表示ダイアログ -->
    <v-card
      v-if="riskFlg !== 1 && registPointMsg"
      class="rp-dialog-content mt-0 pt-0"
    >
      <v-card class="ma-4 rp-dialog-card">
        <div class="rp-dialog-header pl-4">
          <span class="rp-dialog-title">{{ text.pointRegistration }}</span>
        </div>
        <div class="rp-dialog-box rp-dialog-box-confirm pl-4">
          {{ registPointMsg }}
        </div>
        <div class="rp-dialog-box pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="success"
            class="mt-0 ml-4"
            @click="clearMsg"
          >
            <v-icon left>add_box</v-icon>
            {{ text.confirmInfo }}
          </v-btn>
        </div>
      </v-card>
    </v-card>
    <!-- プログレスダイアログ -->
    <v-card
      v-if="this.editFlag !== 0 && this.editLocationMode !== 1"
      class="rp-dialog-content mt-0 pt-0"
    >
      <v-card class="ma-4 rp-dialog-card">
        <div class="rp-dialog-header pl-4">
          <span class="rp-dialog-title">{{ text.progressTitle }}</span>
        </div>
        <div class="rp-dialog-box rp-dialog-box-progress pl-4">
          <span v-if="!registPointErrMsg">{{ text.progressMsg }}</span>
          <span v-else>{{ registPointErrMsg }}</span>
          <div class="rp-td-item-loading">
            <v-progress-linear
              :value="progressValue"
              height="25"
              color="orange lighten-2"
              class="px-4"
            >
              {{ progressValue }}%</v-progress-linear
            >
          </div>
          <div class="rp-td-item-cancel">
            <v-spacer></v-spacer>
            <v-btn
              class="mt-3 mr-5"
              small
              outlined
              color="success"
              @click="registCancel()"
              ><v-icon left>clear</v-icon>{{ text.cancel }}</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-card>
  </v-container>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用登録地点情報画面
 * RegistPoint.vue
 * @author LIS
 */
import mixin from "../../../lib/mixin.js";
import WebStorage from "../../../lib/webStorage.js";
import PageLog from "../../../lib/pageLog.js";
import RpInundation from "../../../components/pc/RpInundation.vue";
import RpEvacuation from "../../../components/pc/RpEvacuation.vue";
import RpTmList from "../../../components/pc/RpTmList.vue";
import RpTwninfo from "../../../components/pc/RpTwninfo.vue";

export default {
  mixins: [mixin],
  components: {
    RpInundation,
    RpEvacuation,
    RpTmList,
    RpTwninfo,
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        pointRegistration: "地点登録",
        confirmInfoMsg1: "登録した地点のリスク判定を行います。",
        confirmInfoMsg2: "リスク判定は、最大５分程度かかる場合があります。",
        confirm: "判定実行",
        cancel: "キャンセル",
        confirmInfo: "確認",
        progressTitle: "リスク判定",
        progressMsg: "判定中...",
      },
    };
  },
  created() {
    /** ストアとクエリが異なる場合は、クエリを正としてストアを更新 */
    if (
      this.$store.state.map.selectPointIndex !=
      parseInt(this.$route.query["pidx"], 10)
    ) {
      this.$store.commit(
        "map/setSelectPointIndex",
        parseInt(this.$route.query["pidx"], 10)
      );
    }
  },
  mounted() {
    // アクセスログ出力
    PageLog.log({
      page_log: "home",
      device_sb: this.$store.state.app.mode,
      fc_flg: this.$store.getters["app/isFldCtl"],
    });

    /** ストアにクエリが示している地点が登録してない場合は */
    let point = parseInt(this.$route.query["pidx"], 10) + 1;
    if (
      WebStorage.getPointInfo(point) == "" ||
      WebStorage.getPointInfo(point) == null
    ) {
      /** 現在のクエリを取得 */
      let setQuery = Object.assign({}, this.$route.query);
      delete setQuery.pidx;
      let setPath = this.$route.path.replace("rp", "ov");
      /** urlを書き換える */
      this.$router.replace({
        path: setPath,
        query: setQuery,
      });
    } else {
      this.$log.debug("[RegistPoint] mounted()");
      this.$store.commit("app/setContent", "RegistPoint");
    }
  },
  computed: {
    /** webストレージより登録地点を取得 */
    pointList() {
      let points = [];
      let info, point;
      for (let i = 1; i <= WebStorage.length(); i++) {
        info = WebStorage.getPointInfo(i);
        point = { name: "地点" + i, pointIndex: "" };
        // 地点が登録されているか判定
        if (info != null && info.name != null && info.pointIndex != null) {
          if (info.name != "") {
            point.name = info.name;
            if (point.name.length > 10) {
              point.name = point.name.substring(0, 8) + "...";
            }
          }
          point.pointIndex = info.pointIndex;
          points.push(point);
        }
      }
      return points;
    },
    /** 選択登録地点を取得 */
    getPointIndex: {
      get() {
        return this.$store.state.map.selectPointIndex;
      },
    },
    /** リスク収集フラグ */
    riskFlg: {
      get() {
        return this.$store.state.viewConfig.riskFlg;
      },
    },
    /** 登録地編集モード */
    editLocationMode: {
      get() {
        return this.$store.state.map.editLocationMode;
      },
    },
    /** 登録中フラグ */
    editFlag: {
      get() {
        return this.$store.state.map.editFlag;
      },
    },
    /** プログレスの値 */
    progressValue: {
      get() {
        let val = (this.$store.state.Telemeter.registPointState / 4) * 100;
        return val;
      },
    },
    /** 地点登録エラーメッセージ */
    registPointErrMsg: {
      get() {
        return this.$store.state.Telemeter.registPointErrMsg;
      },
    },
    /** 地点登録メッセージ */
    registPointMsg: {
      get() {
        return this.$store.state.Telemeter.registPointMsg;
      },
    },
  },
  methods: {
    /** 選択登録地点を登録 */
    setPointIndex(num) {
      this.$store.commit("map/setSelectPointIndex", num);
      // クエリの更新
      this.setPointQuery(num);
    },
    /** タブを選択によりクエリの更新 */
    setPointQuery(num) {
      let setQuery = Object.assign({}, this.$route.query);
      setQuery["pidx"] = num;
      // 選択される登録地点のみ更新し、他のパラメータやパスは変更しない
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /** 確認 */
    confirm() {
      this.$log.debug("[RegistPoint] confirm()");

      let index = this.getPointIndex;
      let point;

      // webストレージから表示情報を取得
      if (index === 0) {
        point = WebStorage.getPoint1Info();
      } else if (index === 1) {
        point = WebStorage.getPoint2Info();
      } else if (index === 2) {
        point = WebStorage.getPoint3Info();
      } else if (index === 3) {
        point = WebStorage.getPoint4Info();
      } else if (index === 4) {
        point = WebStorage.getPoint5Info();
      }

      let centerTwn = {
        townCd: point.twnCd,
        prefCd: point.prefCd,
        address: point.address,
      };
      let maxmin = this.getTownNameRange(point.center);

      // リスク判定を行う
      this.$store.dispatch("Telemeter/getTmDatasByPoint", {
        pointIndex: index,
        name: point.name,
        center: point.center,
        centerTwn: centerTwn,
        centerHeight: point.centerHeight,
        minLatLon: maxmin.minCoord,
        maxLatLon: maxmin.maxCoord,
        zoom: point.zoom,
        token: this.$store.state.app.token,
        iconImg: point.iconImg,
        iconSize: point.iconSize,
      });

      this.$store.commit("map/setEditFlag", 1);
      this.$store.commit("viewConfig/setRiskFlg", 2);
    },
    /** キャンセル */
    cancelConfirm() {
      this.$log.debug("[RegistPoint] cancelConfirm()");
      this.$store.commit("viewConfig/setRiskFlg", 0);
    },
    /** 登録キャンセル */
    registCancel() {
      this.$log.debug("[RegistPoint] registCancel()");

      // ステータスをクリア
      this.$store.commit("map/setEditLocationMode", 0);
      this.$store.commit("map/setEditTmMode", 0);
      this.$store.commit("map/setEditFlag", 0);

      // 地点登録状況に9:キャンセルを設定
      this.$store.commit("Telemeter/setRegistPointState", 9);
    },
    /** 地点登録メッセージのクリア */
    clearMsg() {
      this.$store.commit("Telemeter/setRegistPointMsg", "");
    },
    /** 登録地点名生成 */
    setPointName(name) {
      if (name.length > 5) {
        return name.slice(0, 4) + "…";
      } else {
        return name;
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../../scss/_media_query.scss";
@import "./../../../scss/color.scss";
.regist-point {
  display: flex;
  position: relative;
  flex-direction: column;
  height: 100%;

  .rp-box {
    height: 100%;
    .rp-tab {
      width: 100%;
    }
    .rp-card-list {
      position: relative;
      height: calc(100% - 48px);
    }
    .rp-scroll {
      position: absolute;
      height: 100%;
      overflow: auto;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      & > :not(:first-child) {
        margin-top: 4px;
      }
    }
    .rp-tab {
      margin-bottom: 4px;
      margin-left: 12px;
      display: flex;
      flex-direction: row;
      .rp-tab-btn {
        margin: 0;
        width: 18%;
        text-transform: none !important;
      }
    }
  }

  .rp-dialog-content {
    position: absolute;
    background-color: rgba(lightgray, 0.8);
    z-index: 3030;
    width: 100%;
    height: 100%;

    .rp-dialog-card {
      .rp-header {
        display: flex;
      }
      .rp-dialog-header {
        background-color: $color-header-back;
        color: $color-header-text;
        line-height: 40px;
        height: 40px;
        width: 100%;
      }
      .rp-dialog-box {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
        .rp-dialog-box-confirm {
          font-size: 1rem;
        }
      }
      .rp-dialog-box {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
        .rp-dialog-box-confirm {
          font-size: 1rem;
        }
        .rp-dialog-twn {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          width: 100%;
        }
      }

      .rp-dialog-box-progress {
        display: flex;
        flex-direction: column;
        height: 120px;
        .rp-td-item-loading {
          display: flex;
          justify-content: flex-end;
          width: calc(100% - 20px);
        }
        .rp-td-item-cancel {
          display: flex;
          justify-content: flex-end;
          width: 100%;
        }
      }
    }
  }
}
</style>
